<template>
  <div>
    <header-div v-if="isshow"></header-div>
    <orgheader-div v-else></orgheader-div>
    <div class="zhuantib" :style="'background: url('+banner+') no-repeat center center;'"></div>
    <div class="index-content">
      <div class="container">
        <div class="overhead">
          <div class="nav" style="display: none;">
            <div class="nav-item" v-for="(item,index) in overhead" :key="item.id" :class="{active:nav === index}"
                 @mouseover="navTab(index)">
              <span v-text="item.tagName"></span>
              <i class="iconfont iconxiangyou"></i>
            </div>
          </div>
          <div class="list" style="width: 100%">
            <div v-if="nav === 0">
              <div class="list-box">
                <div class="position-item" v-for="item in showList0" :key="item.user_id">
                  <div class="org-box" @click="toPage('/home/orgDetails/' + item.user_id+'?type=2')">
                    <img :src="urlStr + item.logo" alt="">
                    <h3 class="ovDuo2">{{item.organization_name}}</h3>
                  </div>
                  <div class="obj-box">
                    <div class="ovDna" v-for="cell in item.jobs_list" :key="cell.id"
                         @click="toPage('/home/jobDetails/' + cell.id)">
                      {{cell.jobs_name}}
                    </div>

                  </div>
                  <p v-if="item.jobs_list.length>1" style="line-height: 30px;padding-left: 15px;color: #00a2ea;font-size: 12px;" @click="toPage('/home/orgDetails/' + item.user_id+'?type=2')">【更多职位】</p>
                  <p v-else style="height: 30px;"></p>
                  <div class="label-box">
                    <span v-if="Number(item.video_interview) === 1">视频面试</span>
                    <span class="active">{{item.is_nationwide === 1?'全国':(item.address_city_name[0] === '北京市'?'北京':item.address_city_name[0])}}</span>
                  </div>
                </div>

              </div>
              <el-pagination
                background
                layout="prev, pager, next, jumper"
                :page-size="12"
                :total="list0.length"
                @current-change="setList0"
                :current-page="currentPage0"
              >
              </el-pagination>
            </div>
            <div v-if="nav === 1">
              <div class="list-box">
                <div class="position-item" v-for="item in showList1" :key="item.user_id">
                  <div class="org-box" @click="toPage('/home/orgDetails/' + item.user_id+'?type=2')">
                    <img :src="urlStr + item.logo" alt="">
                    <h3 class="ovDuo2">{{item.organization_name}}</h3>
                  </div>
                  <div class="obj-box">
                    <div class="ovDna" v-for="cell in item.jobs_list" :key="cell.id"
                         @click="toPage('/home/jobDetails/' + cell.id)">
                      {{cell.jobs_name}}
                    </div>
                  </div>

                  <div class="label-box">
                    <span v-if="Number(item.video_interview) === 1">视频面试</span>
                    <span class="active">{{item.is_nationwide === 1?'全国':(item.address_city_name[0] === '北京市'?'北京':item.address_city_name[0])}}</span>
                  </div>
                </div>

              </div>
              <el-pagination
                background
                layout="prev, pager, next, jumper"
                :page-size="12"
                :total="list1.length"
                @current-change="setList1"
                :current-page="currentPage1"
              >
              </el-pagination>
            </div>
            <div v-if="nav === 2">
              <div class="list-box">
                <div class="position-item" v-for="item in showList2" :key="item.user_id">
                  <div class="org-box" @click="toPage('/home/orgDetails/' + item.user_id+'?type=2')">
                    <img :src="urlStr + item.logo" alt="">
                    <h3 class="ovDuo2">{{item.organization_name}}</h3>
                  </div>
                  <div class="obj-box">
                    <div class="ovDna" v-for="cell in item.jobs_list" :key="cell.id"
                         @click="toPage('/home/jobDetails/' + cell.id)">
                      {{cell.jobs_name}}
                    </div>
                  </div>

                  <div class="label-box">
                    <span v-if="Number(item.video_interview) === 1">视频面试</span>
                    <span class="active">{{item.is_nationwide === 1?'全国':(item.address_city_name[0] === '北京市'?'北京':item.address_city_name[0])}}</span>
                  </div>
                </div>

              </div>
              <el-pagination
                background
                layout="prev, pager, next, jumper"
                :page-size="12"
                :total="list2.length"
                @current-change="setList2"
                :current-page="currentPage2"
              >
              </el-pagination>
            </div>
            <div v-if="nav === 3">
              <div class="list-box">
                <div class="position-item" v-for="item in showList3" :key="item.user_id">
                  <div class="org-box" @click="toPage('/home/orgDetails/' + item.user_id+'?type=2')">
                    <img :src="urlStr + item.logo" alt="">
                    <h3 class="ovDuo2">{{item.organization_name}}</h3>
                  </div>
                  <div class="obj-box">
                    <div class="ovDna" v-for="cell in item.jobs_list" :key="cell.id"
                         @click="toPage('/home/jobDetails/' + cell.id)">
                      {{cell.jobs_name}}
                    </div>
                  </div>

                  <div class="label-box">
                    <span v-if="Number(item.video_interview) === 1">视频面试</span>
                    <span class="active">{{item.is_nationwide === 1?'全国':(item.address_city_name[0] === '北京市'?'北京':item.address_city_name[0])}}</span>
                  </div>
                </div>

              </div>
              <el-pagination
                background
                layout="prev, pager, next, jumper"
                :page-size="12"
                :total="list3.length"
                @current-change="setList3"
                :current-page="currentPage3"
              >
              </el-pagination>
            </div>
            <div v-if="nav === 4">
              <div class="list-box">
                <div class="position-item" v-for="item in showList4" :key="item.user_id">
                  <div class="org-box" @click="toPage('/home/orgDetails/' + item.user_id+'?type=2')">
                    <img :src="urlStr + item.logo" alt="">
                    <h3 class="ovDuo2">{{item.organization_name}}</h3>
                  </div>
                  <div class="obj-box">
                    <div class="ovDna" v-for="cell in item.jobs_list" :key="cell.id"
                         @click="toPage('/home/jobDetails/' + cell.id)">
                      {{cell.jobs_name}}
                    </div>
                  </div>

                  <div class="label-box">
                    <span v-if="Number(item.video_interview) === 1">视频面试</span>
                    <span class="active">{{item.is_nationwide === 1?'全国':(item.address_city_name[0] === '北京市'?'北京':item.address_city_name[0])}}</span>
                  </div>
                </div>

              </div>
              <el-pagination
                background
                layout="prev, pager, next, jumper"
                :page-size="12"
                :total="list4.length"
                @current-change="setList4"
                :current-page="currentPage4"
              >
              </el-pagination>
            </div>
            <div v-if="nav === 5">
              <div class="list-box">
                <div class="position-item" v-for="item in showList5" :key="item.user_id">
                  <div class="org-box" @click="toPage('/home/orgDetails/' + item.user_id+'?type=2')">
                    <img :src="urlStr + item.logo" alt="">
                    <h3 class="ovDuo2">{{item.organization_name}}</h3>
                  </div>
                  <div class="obj-box">
                    <div class="ovDna" v-for="cell in item.jobs_list" :key="cell.id"
                         @click="toPage('/home/jobDetails/' + cell.id)">
                      {{cell.jobs_name}}
                    </div>
                  </div>

                  <div class="label-box">
                    <span v-if="Number(item.video_interview) === 1">视频面试</span>
                    <span class="active">{{item.is_nationwide === 1?'全国':(item.address_city_name[0] === '北京市'?'北京':item.address_city_name[0])}}</span>
                  </div>
                </div>

              </div>
              <el-pagination
                background
                layout="prev, pager, next, jumper"
                :page-size="12"
                :total="list5.length"
                @current-change="setList5"
                :current-page="currentPage5"
              >
              </el-pagination>
            </div>
            <div v-if="nav === 6">
              <div class="list-box">
                <div class="position-item" v-for="item in showList6" :key="item.user_id">
                  <div class="org-box" @click="toPage('/home/orgDetails/' + item.user_id+'?type=2')">
                    <img :src="urlStr + item.logo" alt="">
                    <h3 class="ovDuo2">{{item.organization_name}}</h3>
                  </div>
                  <div class="obj-box">
                    <div class="ovDna" v-for="cell in item.jobs_list" :key="cell.id"
                         @click="toPage('/home/jobDetails/' + cell.id)">
                      {{cell.jobs_name}}
                    </div>
                  </div>

                  <div class="label-box">
                    <span v-if="Number(item.video_interview) === 1">视频面试</span>
                    <span class="active">{{item.is_nationwide === 1?'全国':(item.address_city_name[0] === '北京市'?'北京':item.address_city_name[0])}}</span>
                  </div>
                </div>

              </div>
              <el-pagination
                background
                layout="prev, pager, next, jumper"
                :page-size="12"
                :total="list6.length"
                @current-change="setList6"
                :current-page="currentPage6"
              >
              </el-pagination>
            </div>
            <div v-if="nav === 7">
              <div class="list-box">
                <div class="position-item" v-for="item in showList4" :key="item.user_id">
                  <div class="org-box" @click="toPage('/home/orgDetails/' + item.user_id+'?type=2')">
                    <img :src="urlStr + item.logo" alt="">
                    <h3 class="ovDuo2">{{item.organization_name}}</h3>
                  </div>
                  <div class="obj-box">
                    <div class="ovDna" v-for="cell in item.jobs_list" :key="cell.id"
                         @click="toPage('/home/jobDetails/' + cell.id)">
                      {{cell.jobs_name}}
                    </div>
                  </div>

                  <div class="label-box">
                    <span v-if="Number(item.video_interview) === 1">视频面试</span>
                    <span class="active">{{item.is_nationwide === 1?'全国':(item.address_city_name[0] === '北京市'?'北京':item.address_city_name[0])}}</span>
                  </div>
                </div>

              </div>
              <el-pagination
                background
                layout="prev, pager, next, jumper"
                :page-size="12"
                :total="list7.length"
                @current-change="setList7"
                :current-page="currentPage7"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer-div v-if="isshow"></footer-div>
    <orgfooter-div v-else></orgfooter-div>
  </div>
</template>

<script>

  import config from '../config/index'
  import headerDiv from '../pageMember/components/header'
  import footerDiv from '../pageMember/components/footer'
  import orgheaderDiv from '../pageOrg/components/header'
  import orgfooterDiv from '../pageOrg/components/footer'

  export default {
    name: "index",
    data() {
      return {
        isshow: false,
        urlStr: config.urlStr + '/', // 域名
        nav: 0,
        overhead: [
          {id: 0, tagName: '全部'},
          {id: 1, tagName: '基金会'},
          {id: 2, tagName: '社会服务机构'},
          {id: 3, tagName: '社团/协会'},
          {id: 4, tagName: '国际机构'},
          {id: 5, tagName: '社会企业'},
          {id: 6, tagName: '商业企业'},
          {id: 7, tagName: '其他'},
        ], // 职位显示的数据
        currentPage0: 1,
        list0: [],
        showList0: [],

        currentPage1: 1,
        list1: [],
        showList1: [],

        currentPage2: 1,
        list2: [],
        showList2: [],

        currentPage3: 1,
        list3: [],
        showList3: [],

        currentPage4: 1,
        list4: [],
        showList4: [],

        currentPage5: 1,
        list5: [],
        showList5: [],

        currentPage6: 1,
        list6: [],
        showList6: [],

        currentPage7: 1,
        list7: [],
        showList7: [],

        banner: ''
      }
    },
    computed: {},
    created() {
      // 默认选择北京市
      this.$store.state.selectionAddress = window.sessionStorage.getItem('selectionAddress') ? JSON.parse(window.sessionStorage.getItem('selectionAddress')) : {
        categoryname: "北京市",
        city_id: 110100,
        parentid: 1,
        spell: "beijingshi"
      }
      if (JSON.parse(window.localStorage.getItem('user')) === null) {
        this.isshow = true
      } else {
        JSON.parse(window.localStorage.getItem('user')).user_type !== 2 ? this.isshow = true : this.isshow = false
      }
      this.init()
    },
    methods: {
      init() {
        this.$api.apiContent.customSXHBannercustomSXHJobsAll({
          sxhId: this.$route.query.id,
        }).then(res => {
          this.banner = config.urlStr + '/' + res.data.pc_image
        }).catch(e => {
          console.log(e)
        })
        // 栏目1 (全部)
        this.$api.apiContent.customSXHJobsAll({
          sxhId: this.$route.query.id,
          page: 1,
          pageSize: 10000
        }).then(res => {
          this.list0 = res.data
          this.list0.map(item => {
            item.address_city_name = item.address_city_name.split('|')
          })
          this.showList0 = res.data.slice(0, 12)
        }).catch(e => {
          console.log(e)
        })
        // (栏目2) 基金会)
        this.$api.apiContent.customSXHJobsJJH({
          sxhId: this.$route.query.id,
          page: 1,
          pageSize: 10000
        }).then(res => {
          this.list1 = res.data
          this.list1.map(item => {
            item.address_city_name = item.address_city_name.split('|')
          })
          this.showList1 = res.data.slice(0, 12)
        }).catch(e => {
          console.log(e)
        })
        // (栏目3) 社会服务机构)
        this.$api.apiContent.customSXHJobsSHZZ({
          sxhId: this.$route.query.id,
          page: 1,
          pageSize: 10000
        }).then(res => {
          this.list2 = res.data
          this.list2.map(item => {
            item.address_city_name = item.address_city_name.split('|')
          })
          this.showList2 = res.data.slice(0, 12)
        }).catch(e => {
          console.log(e)
        })
        // (栏目4) 社团/协会)
        this.$api.apiContent.customSXHJobsXHST({
          sxhId: this.$route.query.id,
          page: 1,
          pageSize: 10000
        }).then(res => {
          this.list3 = res.data
          this.list3.map(item => {
            item.address_city_name = item.address_city_name.split('|')
          })
          this.showList3 = res.data.slice(0, 12)
        }).catch(e => {
          console.log(e)
        })

        // (栏目5) 国际机构)
        this.$api.apiContent.customSXHJobsGJSH({
          sxhId: this.$route.query.id,
          page: 1,
          pageSize: 10000
        }).then(res => {
          this.list4 = res.data
          this.list4.map(item => {
            item.address_city_name = item.address_city_name.split('|')
          })
          this.showList4 = res.data.slice(0, 12)
        }).catch(e => {
          console.log(e)
        })

        // (栏目6) 社会企业)
        this.$api.apiContent.customSXHJobsSHQY({
          sxhId: this.$route.query.id,
          page: 1,
          pageSize: 10000
        }).then(res => {
          this.list5 = res.data
          this.list5.map(item => {
            item.address_city_name = item.address_city_name.split('|')
          })
          this.showList5 = res.data.slice(0, 12)
        }).catch(e => {
          console.log(e)
        })

        // (栏目7) 商业企业)
        this.$api.apiContent.customSXHJobsSYQY({
          sxhId: this.$route.query.id,
          page: 1,
          pageSize: 10000
        }).then(res => {
          this.list6 = res.data
          this.list6.map(item => {
            item.address_city_name = item.address_city_name.split('|')
          })
          this.showList6 = res.data.slice(0, 12)
        }).catch(e => {
          console.log(e)
        })

        // (栏目8) 其它)
        this.$api.apiContent.customSXHJobsQT({
          sxhId: this.$route.query.id,
          page: 1,
          pageSize: 10000
        }).then(res => {
          this.list7 = res.data
          this.list7.map(item => {
            item.address_city_name = item.address_city_name.split('|')
          })
          this.showList7 = res.data.slice(0, 12)
        }).catch(e => {
          console.log(e)
        })

      },

      //  栏目1分页
      setList0(e) {
        this.showList0 = this.list0.slice((e - 1) * 12, e * 12)
        this.currentPage0 = e
      },
      //  栏目2分页
      setList1(e) {
        this.showList1 = this.list1.slice((e - 1) * 12, e * 12)
        this.currentPage1 = e
      },
      //  栏目3分页
      setList2(e) {
        this.showList2 = this.list2.slice((e - 1) * 12, e * 12)
        this.currentPage2 = e
      },
      //  栏目4分页
      setList3(e) {
        this.showList3 = this.list3.slice((e - 1) * 12, e * 12)
        this.currentPage3 = e
      },
      //  栏目5分页
      setList4(e) {
        this.showList4 = this.list3.slice((e - 1) * 12, e * 12)
        this.currentPage4 = e
      },
      //  栏目6分页
      setList5(e) {
        this.showList5 = this.list3.slice((e - 1) * 12, e * 12)
        this.currentPage5 = e
      },
      //  栏目7分页
      setList6(e) {
        this.showList6 = this.list3.slice((e - 1) * 12, e * 12)
        this.currentPage6 = e
      },
      //  栏目8分页
      setList7(e) {
        this.showList7 = this.list3.slice((e - 1) * 12, e * 12)
        this.currentPage7 = e
      },


      //  推荐去详情
      toDetail(id) {
        this.$router.push('/home/jobDetails/' + id)
      },
      navTab(num) {
        this.nav = num
      },

      // 跳转页面
      toPage(router) {
        this.$router.push(router)
      }
    },
    components: {
      headerDiv,
      footerDiv,
      orgheaderDiv,
      orgfooterDiv
    }
  }
</script>

<style scoped lang="scss">
  .zhuantib {
    width: 100%;
    height: 600px;
    background: url('http://manage.api.sttts.org.cn/uploads/zhuanti/shuangxuanhui/zhuantib.png') no-repeat center center;
  }

  .index-content {
    margin: 20px 0;

    .overhead {
      display: flex;
      overflow: hidden;
      height: 915px;
      background: #fff;
      margin-bottom: 28px;

      .nav {
        width: 305px;
        min-height: 520px;
        padding: 17px 0;

        .nav-item {
          display: flex;
          justify-content: space-between;
          height: 60px;
          font-size: 16px;

          span {
            display: block;
            line-height: 60px;
            margin: 0 24px;
          }

          i {
            display: block;
            line-height: 60px;
            margin-right: 42px;
            font-size: 16px;
          }
        }

        .nav-item.active {
          border: solid 1px #a8dff7;
          border-right: 0;
          position: relative;

          span {
            font-weight: 500;
            color: #00a2ea;
          }

          i {
            display: none;
          }

          &:after {
            position: absolute;
            top: 0;
            right: -1px;
            content: '';
            width: 1px;
            height: 59px;
            background: #fff;
          }
        }
      }

      .list {

        width: 895px;
        height: 915px;
        padding: 17px;
        border: solid 1px #a8dff7;

        .list-box {
          display: flex;
          justify-content: flex-start;
          align-content: flex-start;
          flex-wrap: wrap;
          height: 800px;


          .position-item {
            width: 285px;
            height: 220px;
            padding: 10px;
            //border-right: 1px solid #e8ecf2;
            border-bottom: 1px solid #e8ecf2;

            .org-box {
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin-bottom: 20px;
              cursor: pointer;

              img {
                display: block;
                width: 60px;
                height: 60px;
                border-radius: 60px;
                margin-right: 10px;
              }

              h3 {
                flex: 1;
                line-height: 24px;
                font-weight: bold;
                font-size: 16px;
              }
            }

            .obj-box {
              height: 60px;
              overflow: hidden;
              //margin-bottom: 10px;

              div {
                height: 30px;
                line-height: 30px;
                position: relative;
                padding-left: 25px;
                cursor: pointer;

                &::before {
                  position: absolute;
                  top: 13px;
                  left: 10px;
                  content: '';
                  width: 6px;
                  height: 6px;
                  background: #00a2ea;
                  border-radius: 6px;
                }
              }
            }

            .label-box {
              display: flex;
              align-items: center;

              span {
                display: block;
                height: 24px;
                line-height: 24px;
                padding: 0 10px;
                margin-right: 10px;
                border: 1px solid #00a2ea;
                color: #00a2ea;

                &.active {
                  border-color: #5daf34;
                  color: #5daf34;
                }
              }
            }
          }

          .position-item:nth-child(3n) {
            padding-left: 17px;
            border-right: 0;
          }

          .position-item:nth-child(10), .position-item:nth-child(11), .position-item:nth-child(12), {
            border-bottom: 0;
          }
        }

      }
    }


  }


</style>
